// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__158LR","content":"LayoutSettings_content__3B1Mh"};